export enum TipoAerovale {
    Aerocombustible = 0,
    Aeroespecialidad = 1,
    Combustible = 2,
    Alije = 3,
    Servicio = 4,

    Devolucion = 5,
    Anticipada = 6,
    IATANivelDosTres = 7
}